export default defineNuxtPlugin(() => {
  const isTrustedBot = useState<boolean>('isTrustedBot');

  return {
    provide: {
      isTrustedBot
    }
  };
});
